import { atom } from 'recoil'

const navigatorIndexState = atom({
  key: 'navigatorIndexState',
  default: 0,
})

export default navigatorIndexState
